import React, { memo } from "react";
import AiPrompt from "./AiPrompt";

const ChatPrompts = memo(({ getChat, prompts }) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {prompts?.map((prompt) => (
        <AiPrompt
          key={prompt.id}
          prompt={prompt.prompt}
          text={prompt.text}
          getChat={getChat}
        />
      ))}
    </div>
  );
});

export default ChatPrompts;
